import React from 'react';
import styled from '@emotion/styled';
import { getGravatar } from 'utils/getGravatar';
import { SmallGrayText } from 'components/typography';
import { Author } from 'data/SingleArticle/types';
import { mediaQueries } from 'components/mediaQueries';

type Props = { author: Author };

export const AuthorFeature = ({ author }: Props) => {
  return (
    <Outer>
      <ContentWrapper>
        <Image src={getGravatar(author.email)} alt={author.name + ' picture'} />
        <TextWrapper>
          <Name>{author.name}</Name>
          <SmallGrayText>{author.bio}</SmallGrayText>
        </TextWrapper>
      </ContentWrapper>
    </Outer>
  );
};

const Outer = styled.div``;

const ContentWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr;
  padding: 0 22px;
  ${mediaQueries.tablet} {
    grid-template-columns: 70px auto;
  }
`;

const Image = styled.img`
  border-radius: 50%;
  width: 70px;
  height: 70px;
`;

const TextWrapper = styled.div``;

const Name = styled.p`
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 600;
`;
